
var Globalize = require('globalize/dist/globalize-runtime');
require('globalize/dist/globalize-runtime/number');
require('globalize/dist/globalize-runtime/plural');
require('globalize/dist/globalize-runtime/message');
require('globalize/dist/globalize-runtime/date');
var validateParameterTypeNumber = Globalize._validateParameterTypeNumber;
var validateParameterPresence = Globalize._validateParameterPresence;
var numberRound = Globalize._numberRound;
var numberFormat = Globalize._numberFormat;
var numberFormatterFn = Globalize._numberFormatterFn;
var validateParameterTypeString = Globalize._validateParameterTypeString;
var numberParse = Globalize._numberParse;
var numberParserFn = Globalize._numberParserFn;
var pluralGeneratorFn = Globalize._pluralGeneratorFn;
var validateParameterTypeMessageVariables = Globalize._validateParameterTypeMessageVariables;
var messageFormat = Globalize._messageFormat;
var messageFormatterFn = Globalize._messageFormatterFn;
var validateParameterTypeDate = Globalize._validateParameterTypeDate;
var dateToPartsFormat = Globalize._dateToPartsFormat;
var dateToPartsFormatterFn = Globalize._dateToPartsFormatterFn;
var dateFormat = Globalize._dateFormat;
var dateFormatterFn = Globalize._dateFormatterFn;
var dateTokenizer = Globalize._dateTokenizer;
var dateParse = Globalize._dateParse;
var dateParserFn = Globalize._dateParserFn;

Globalize.b224144833 = numberFormatterFn(["",,2,0,0,,,,,,"","00","-00","-","",numberRound(),"∞","非數值",{".":".",",":",","%":"%","+":"+","-":"-","E":"E","‰":"‰"},]);
Globalize.b644237057 = numberFormatterFn(["",,4,0,0,,,,,,"","0000","-0000","-","",numberRound(),"∞","非數值",{".":".",",":",","%":"%","+":"+","-":"-","E":"E","‰":"‰"},]);
Globalize.b561430475 = numberFormatterFn(["",,1,0,0,,,,,,"","0","-0","-","",numberRound(),"∞","非數值",{".":".",",":",","%":"%","+":"+","-":"-","E":"E","‰":"‰"},]);
Globalize.a473705916 = numberParserFn([{".":".",",":",","%":"%","+":"+","-":"-","E":"E","‰":"‰"},,{"infinity":/^∞/,"nan":/^非數值/,"negativePrefix":/^-/,"negativeSuffix":/^/,"number":/^\d+/,"prefix":/^/,"suffix":/^/}]);
Globalize.a1430352691 = pluralGeneratorFn(function(n
) {
  return 'other';
});
Globalize.a1909254815 = messageFormatterFn((function(  ) {
  return function(d) { return "登入"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.b1857148533 = messageFormatterFn((function(  ) {
  return function(d) { return "登入"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.b211815168 = messageFormatterFn((function(  ) {
  return function(d) { return "電郵地址"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a1541384281 = messageFormatterFn((function(  ) {
  return function(d) { return "密碼"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.b735332232 = messageFormatterFn((function(  ) {
  return function(d) { return "我正使用公共或共用裝置"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.b1276581583 = messageFormatterFn((function(  ) {
  return function(d) { return "你用的不是自己的裝置？剔選此方格會於閒置時提早自動登出帳戶。"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a1833741068 = messageFormatterFn((function(  ) {
  return function(d) { return "保持登入"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.b81131730 = messageFormatterFn((function(  ) {
  return function(d) { return "剔選此方格你的帳戶即會於此裝置中維持登入，直至你手動登出為止。如正使用共用裝置，請勿選取此格。"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.b2094317398 = messageFormatterFn((function(  ) {
  return function(d) { return "忘記密碼？"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.b953528731 = messageFormatterFn((function(  ) {
  return function(d) { return "繼續"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.b1015859080 = messageFormatterFn((function(  ) {
  return function(d) { return "取消"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a1236295121 = messageFormatterFn((function(  ) {
  return function(d) { return "返回"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a631041875 = messageFormatterFn((function(  ) {
  return function(d) { return "重新載入"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a1664638744 = messageFormatterFn((function(  ) {
  return function(d) { return "登入即表示我同意 " + d["0"] + " <a href=" + d["1"] + " " + d["3"] + ">條款及細則</a>和<a href=" + d["2"] + " " + d["4"] + ">私隱聲明</a>。"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a797816906 = messageFormatterFn((function(  ) {
  return function(d) { return "登入即表示我同意 " + d["0"] + " <a href=" + d["1"] + " " + d["5"] + ">條款及細則</a>、<a href=" + d["2"] + " " + d["6"] + ">私隱聲明</a>及 <a href=" + d["3"] + " " + d["7"] + ">" + d["4"] + " 條款及細則</a>。"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.b1571250546 = messageFormatterFn((function(  ) {
  return function(d) { return "登入即表示我確認加入 " + d["4"] + "，且同意 " + d["0"] + " <a href=" + d["1"] + " " + d["5"] + ">條款及細則</a>、<a href=" + d["2"] + " " + d["6"] + ">私隱聲明</a>及 <a href=" + d["3"] + " " + d["7"] + ">" + d["4"] + " 條款及細則</a>。"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.b582082973 = messageFormatterFn((function(  ) {
  return function(d) { return "我們進行了例行安全檢查，你的帳戶已暫時停用。你的個人資料安全無虞，但帳戶需要重設密碼。請按一下下方的「忘記密碼？」連結更改密碼，然後重新登入。"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.b1794914265 = messageFormatterFn((function(  ) {
  return function(d) { return "電郵地址及密碼不符，請再試一次。"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a677043924 = messageFormatterFn((function(  ) {
  return function(d) { return "很抱歉，系統發生錯誤。"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a1312936538 = messageFormatterFn((function(  ) {
  return function(d) { return "很抱歉，系統發生錯誤。請稍後再試一次。"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.b2041798792 = messageFormatterFn((function(  ) {
  return function(d) { return "請輸入你的電郵地址。"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a95481609 = messageFormatterFn((function(  ) {
  return function(d) { return "請輸入有效的電郵地址。"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a1697901009 = messageFormatterFn((function(  ) {
  return function(d) { return "請輸入你的密碼。"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.b1954551301 = messageFormatterFn((function(  ) {
  return function(d) { return "正在檢查登入資料"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a1958166122 = messageFormatterFn((function(  ) {
  return function(d) { return "隱藏密碼"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.b2022459035 = messageFormatterFn((function(  ) {
  return function(d) { return "顯示密碼"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a1548380985 = messageFormatterFn((function(  ) {
  return function(d) { return "未有帳戶？<span><a id=\"createAcctRedirectLink\" href=" + d["0"] + ">按此建立</a></span>"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a501701246 = messageFormatterFn((function(  ) {
  return function(d) { return "登入"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.b2084592277 = messageFormatterFn((function(  ) {
  return function(d) { return "無法使用 " + d["0"] + " 帳戶登入"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.b697607153 = messageFormatterFn((function(  ) {
  return function(d) { return "你可以使用相同的電郵登入 " + d["0"] + " 帳戶，只需重設密碼即可。此操作不會影響你的 " + d["1"] + " 帳戶。"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.b1054398595 = messageFormatterFn((function(  ) {
  return function(d) { return "使用下方按鈕重設密碼後，你就可以直接透過電郵和新的密碼登入 " + d["0"] + "。"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a240876790 = messageFormatterFn((function(  ) {
  return function(d) { return "SSO 登入"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.b1620500802 = messageFormatterFn((function(  ) {
  return function(d) { return "透過單一登入功能登入"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.b1282338058 = messageFormatterFn((function(  ) {
  return function(d) { return "或使用你的 " + d["0"] + " 帳戶"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a265770281 = messageFormatterFn((function(  ) {
  return function(d) { return "一訂即賺免費旅遊積分，除了可憑會員價大慳一筆，更可以輕鬆查閱行程。"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.b1211010749 = messageFormatterFn((function(  ) {
  return function(d) { return "這次行程後可賺取 " + d["0"] + " 分 Expedia Rewards 積分"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a967434688 = messageFormatterFn((function(  ) {
  return function(d) { return "登入 " + d["0"] + " 帳戶"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a1782544344 = messageFormatterFn((function(  ) {
  return function(d) { return "於新分頁開啟"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.b966699452 = messageFormatterFn((function(  ) {
  return function(d) { return "條款及細則 (" + d["0"] + ")"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.b68503718 = messageFormatterFn((function(  ) {
  return function(d) { return "私隱聲明 (" + d["0"] + ")"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a193685225 = messageFormatterFn((function(  ) {
  return function(d) { return "One Key 獎賞計劃條款及細則 (" + d["0"] + ") "; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.b1029451618 = messageFormatterFn((function(  ) {
  return function(d) { return "忘記密碼"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.b1832702439 = messageFormatterFn((function(  ) {
  return function(d) { return "重設密碼"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.b298376979 = messageFormatterFn((function(  ) {
  return function(d) { return "請輸入你的電郵地址，我們會發送重設密碼的連結給你。"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a1697235807 = messageFormatterFn((function(  ) {
  return function(d) { return "發送重設連結"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a679034660 = messageFormatterFn((function(  ) {
  return function(d) { return "檢查郵箱"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a44504780 = messageFormatterFn((function(  ) {
  return function(d) { return "我們己發送附有重設密碼連結的電郵至 " + d["0"] + "。"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a44505741 = messageFormatterFn((function(  ) {
  return function(d) { return "你可能需要數分鐘後才會收到電郵，如未有於 10 分鐘內收到電郵，請檢查你的濫發郵件及垃圾郵件夾。"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a115029865 = messageFormatterFn((function(  ) {
  return function(d) { return "重發連結"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a1363594735 = messageFormatterFn((function(  ) {
  return function(d) { return "已發送新的連結。"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a2023938366 = messageFormatterFn((function(  ) {
  return function(d) { return "正在驗證帳戶"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.b772418370 = messageFormatterFn((function(  ) {
  return function(d) { return "設定密碼"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a1813067257 = messageFormatterFn((function(  ) {
  return function(d) { return "歡迎回來"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.b306344691 = messageFormatterFn((function(  ) {
  return function(d) { return "請設定獨一無二的密碼。"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.b1915493432 = messageFormatterFn((function(  ) {
  return function(d) { return "設定完成"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.b31104523 = messageFormatterFn((function(  ) {
  return function(d) { return "現在你可以使用新密碼繼續。"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.b1494982480 = messageFormatterFn((function(  ) {
  return function(d) { return "重設密碼"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a870757901 = messageFormatterFn((function(  ) {
  return function(d) { return "很抱歉，此要求已過期。如你仍需更改密碼，請於下方發送新的密碼重設電郵。"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a2077235805 = messageFormatterFn((function(  ) {
  return function(d) { return "重發連結"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.b1253784440 = messageFormatterFn((function(  ) {
  return function(d) { return "正在儲存密碼"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.b341678460 = messageFormatterFn((function(  ) {
  return function(d) { return "建立帳戶"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a1388880488 = messageFormatterFn((function(  ) {
  return function(d) { return "建立帳戶"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a1416916099 = messageFormatterFn((function(  ) {
  return function(d) { return "電郵地址"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.b1265502213 = messageFormatterFn((function(  ) {
  return function(d) { return "請輸入你的電郵地址。"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a463902412 = messageFormatterFn((function(  ) {
  return function(d) { return "請輸入有效的電郵地址。"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.b843717598 = messageFormatterFn((function(  ) {
  return function(d) { return "名字"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.b2068778086 = messageFormatterFn((function(  ) {
  return function(d) { return "請輸入你的英文名字，例如 Dai Man。"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a1978634108 = messageFormatterFn((function(  ) {
  return function(d) { return "姓氏"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.b2078756604 = messageFormatterFn((function(  ) {
  return function(d) { return "請輸入你的英文姓氏，例如 Chan。"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.b2039540867 = messageFormatterFn((function(  ) {
  return function(d) { return "請輸入英文姓名。"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.b1465950730 = messageFormatterFn((function(  ) {
  return function(d) { return "密碼"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.b1228374146 = messageFormatterFn((function(  ) {
  return function(d) { return "請輸入你的密碼。"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a1332093709 = messageFormatterFn((function(  ) {
  return function(d) { return "請輸入有效的密碼。"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a226789331 = messageFormatterFn((function(  ) {
  return function(d) { return "9-64 個字元"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a226790292 = messageFormatterFn((function(  ) {
  return function(d) { return "由字母和號碼組成"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a226791253 = messageFormatterFn((function(  ) {
  return function(d) { return "至少 1 個特殊字元 (如 ~" + "#" + "@$%&!*_?^-)"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a226792214 = messageFormatterFn((function(  ) {
  return function(d) { return "不得使用空格"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a586096067 = messageFormatterFn((function(  ) {
  return function(d) { return "密碼長度必須介乎 8 至 64 個字元。"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a1551198512 = messageFormatterFn((function(  ) {
  return function(d) { return "密碼不得與電郵地址相同。"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a311006701 = messageFormatterFn((function(  ) {
  return function(d) { return "密碼不得使用空格。"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a187831269 = messageFormatterFn((function(  ) {
  return function(d) { return "建立帳戶即表示我同意 " + d["0"] + " <a href=" + d["1"] + " " + d["3"] + ">條款及細則</a>和<a href=" + d["2"] + " " + d["4"] + ">私隱聲明</a>。"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.b728565603 = messageFormatterFn((function(  ) {
  return function(d) { return "建立帳戶即表示我同意 " + d["0"] + " <a href=" + d["1"] + " " + d["5"] + ">條款及細則</a>、<a href=" + d["2"] + " " + d["6"] + ">私隱聲明</a>及 <a href=" + d["3"] + " " + d["7"] + ">" + d["4"] + " 條款及細則</a>。"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a774235006 = messageFormatterFn((function(  ) {
  return function(d) { return "我想透過電郵收取 " + d["0"] + " 的旅遊優惠、特別推廣及其他資訊。"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a1835522993 = messageFormatterFn((function(  ) {
  return function(d) { return "我想透過電郵收取 " + d["0"] + " 的旅遊優惠、特別推廣及其他資訊，推廣電郵可隨時取消訂閱。"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a22663233 = messageFormatterFn((function(  ) {
  return function(d) { return "我想透過電郵收取 " + d["0"] + " 的度假靈感、特別推廣及其他資訊。"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a652477390 = messageFormatterFn((function(  ) {
  return function(d) { return "我想透過電郵收取 " + d["0"] + " 的度假靈感、特別推廣及其他資訊，推廣電郵可隨時取消訂閱。"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a334103554 = messageFormatterFn((function(  ) {
  return function(d) { return "繼續"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a527826641 = messageFormatterFn((function(  ) {
  return function(d) { return "已有帳戶？<span><a id=\"signinRedirectLink\" href=" + d["0"] + ">登入</a></span>"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a1211426380 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " 你好！"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a665032314 = messageFormatterFn((function(  ) {
  return function(d) { return "有 " + d["0"] + " 帳戶在手，世界等你隨時出走。"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.b667815741 = messageFormatterFn((function(  ) {
  return function(d) { return "繼續"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a1110481518 = messageFormatterFn((function(  ) {
  return function(d) { return "請輸入安全強度更高的密碼。"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a1118821043 = messageFormatterFn((function(  ) {
  return function(d) { return "至少 8 個字元"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.b975643561 = messageFormatterFn((function(  ) {
  return function(d) { return "密碼強度"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.b1929641205 = messageFormatterFn((function(  ) {
  return function(d) { return "弱"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.b715282326 = messageFormatterFn((function(  ) {
  return function(d) { return "強"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.b1860151360 = messageFormatterFn((function(  ) {
  return function(d) { return "極強"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.b930194011 = messageFormatterFn((function(  ) {
  return function(d) { return "避免使用易猜的替換字，如以「@」代替「a」"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a1783421517 = messageFormatterFn((function(  ) {
  return function(d) { return "避免使用倒轉串寫的常見字"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a311993611 = messageFormatterFn((function(  ) {
  return function(d) { return "使用部分大楷字元"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a140367660 = messageFormatterFn((function(  ) {
  return function(d) { return "首字以外使用大楷字元"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.b2126164688 = messageFormatterFn((function(  ) {
  return function(d) { return "避免使用與你有關的日期和年份"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a1784342374 = messageFormatterFn((function(  ) {
  return function(d) { return "避免使用最近年份"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.b571099583 = messageFormatterFn((function(  ) {
  return function(d) { return "避免使用與你有關的年份"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a69225100 = messageFormatterFn((function(  ) {
  return function(d) { return "避免使用常見的字元排序"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a577983974 = messageFormatterFn((function(  ) {
  return function(d) { return "避免使用重複的字詞和字元"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.b658962230 = messageFormatterFn((function(  ) {
  return function(d) { return "使用更長的鍵盤模式並多次更改輸入順序"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.b2113334545 = messageFormatterFn((function(  ) {
  return function(d) { return "加入更多不常見的字詞"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a1498816795 = messageFormatterFn((function(  ) {
  return function(d) { return "使用多個字詞組合，但避免使用常用字句"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.b762952130 = messageFormatterFn((function(  ) {
  return function(d) { return "無需使用符號、數字或大楷字母都可建立高強度密碼"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.b590105531 = messageFormatterFn((function(  ) {
  return function(d) { return "此電郵地址已有 " + d["0"] + " 帳戶。"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.b1167016727 = messageFormatterFn((function(  ) {
  return function(d) { return "我們已發送了完成建立帳戶的驗證電郵給你。"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a1610713368 = messageFormatterFn((function(  ) {
  return function(d) { return "正在處理註冊申請"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.b518229756 = messageFormatterFn((function(  ) {
  return function(d) { return "名字不得少於 2 個字元。"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a1764624746 = messageFormatterFn((function(  ) {
  return function(d) { return "姓氏不得少於 2 個字元。"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a729820082 = messageFormatterFn((function(  ) {
  return function(d) { return "名字不得超過 100 個字元。"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.b1282292712 = messageFormatterFn((function(  ) {
  return function(d) { return "姓氏不得超過 100 個字元。"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a1699139117 = messageFormatterFn((function(  ) {
  return function(d) { return "名字不得包括特殊字元。"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a794027283 = messageFormatterFn((function(  ) {
  return function(d) { return "姓氏不得包括特殊字元。"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a1358584523 = messageFormatterFn((function(  ) {
  return function(d) { return "我同意以下所有陳述"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.b392659561 = messageFormatterFn((function(  ) {
  return function(d) { return "我確認已年滿 18 歲，且已閱讀並同意<a href=" + d["0"] + " " + d["1"] + ">使用條款</a>及<a href=" + d["2"] + " " + d["3"] + ">條款及細則" + d["4"] + "</a> (必須同意)"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a1137637899 = messageFormatterFn((function(  ) {
  return function(d) { return "我同意按<a href=" + d["0"] + " " + d["1"] + ">私隱政策</a>所述收集並使用我的個人資料 (必須同意)"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.b115649054 = messageFormatterFn((function(  ) {
  return function(d) { return "我同意按<a href=" + d["0"] + " " + d["1"] + ">私隱政策</a>所述向包括韓國或海外的第三方提供我的個人資料 (必須同意)"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.b57198369 = messageFormatterFn((function(  ) {
  return function(d) { return "請接受條款繼續。"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a1971458203 = messageFormatterFn((function(  ) {
  return function(d) { return "請接受條款以繼續"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.b540151209 = messageFormatterFn((function(  ) {
  return function(d) { return "請剔選方格以繼續"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a1117284560 = messageFormatterFn((function(  ) {
  return function(d) { return "透過 " + d["0"] + " 建立帳戶"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.b716262546 = messageFormatterFn((function(  ) {
  return function(d) { return "避免使用空格、姓名、電郵或以前用過的密碼。"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.b1194668626 = messageFormatterFn((function(  ) {
  return function(d) { return "很抱歉，系統發生錯誤。請稍候片刻，然後再試一次。"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a523160084 = messageFormatterFn((function(  ) {
  return function(d) { return "驗證手機號碼"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.b873199867 = messageFormatterFn((function(  ) {
  return function(d) { return "我們會向你的手機發送單次使用的驗證碼，確保你的帳戶安全。"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.b459276798 = messageFormatterFn((function(  ) {
  return function(d) { return "發送"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.b874281595 = messageFormatterFn((function(  ) {
  return function(d) { return "© " + d["1"] + " " + d["0"] + " 保留一切權利。"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a1941303507 = messageFormatterFn((function(  ) {
  return function(d) { return "條款及細則"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.b2051117484 = messageFormatterFn((function(  ) {
  return function(d) { return "私隱政策"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a1608117237 = messageFormatterFn((function(  ) {
  return function(d) { return "發送短訊"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.b1472629440 = messageFormatterFn((function(  ) {
  return function(d) { return "輸入驗證碼"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.b247810382 = messageFormatterFn((function(  ) {
  return function(d) { return "驗證碼"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a1602110693 = messageFormatterFn((function(  ) {
  return function(d) { return "重發驗證碼"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a658573446 = messageFormatterFn((function(  ) {
  return function(d) { return "更改手機號碼"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a354193646 = messageFormatterFn((function(  ) {
  return function(d) { return "驗證碼已重新發送。"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.b680862503 = messageFormatterFn((function(  ) {
  return function(d) { return "請輸入我們剛發送至 " + d["0"] + " 的 6 位驗證碼。"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.b1768541164 = messageFormatterFn((function(  ) {
  return function(d) { return "正在檢查驗證碼"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.b987807885 = messageFormatterFn((function(  ) {
  return function(d) { return "此驗證碼不正確。請重發代碼再試一次。"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.b371351501 = messageFormatterFn((function(  ) {
  return function(d) { return "或透過以下帳戶登入"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.b1127563709 = messageFormatterFn((function(  ) {
  return function(d) { return "免費註冊會員，預訂數以萬間酒店即慳平均 " + d["0"] + "%！"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a1440900561 = messageFormatterFn((function(  ) {
  return function(d) { return "或者"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a1047903503 = messageFormatterFn((function(  ) {
  return function(d) { return "其他登入方式"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a1048262917 = messageFormatterFn((function(  ) {
  return function(d) { return "其他註冊方式"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a2002352677 = messageFormatterFn((function(  ) {
  return function(d) { return "使用 Google 帳戶註冊"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a472336260 = messageFormatterFn((function(  ) {
  return function(d) { return "登入失敗，請再試一次，或於此網站建立帳戶。"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.b776327042 = messageFormatterFn((function(  ) {
  return function(d) { return "無法透過電話號碼登入，請確認社交帳戶已設定為可共用電郵地址。"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.b117799050 = messageFormatterFn((function(  ) {
  return function(d) { return "免費註冊會員，預訂數以萬間酒店即慳至少 " + d["0"] + "%！"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.b331393445 = messageFormatterFn((function(  ) {
  return function(d) { return "使用 Google 帳戶登入"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a812752080 = messageFormatterFn((function(  ) {
  return function(d) { return "使用 NAVER 帳戶登入"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a787702714 = messageFormatterFn((function(  ) {
  return function(d) { return "登入次數已超出上限，請稍後再試。"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a373140813 = messageFormatterFn((function(  ) {
  return function(d) { return "使用生物識別登入"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a765402291 = messageFormatterFn((function(  ) {
  return function(d) { return "使用生物識別功能，無需輸入密碼即可登入帳戶。"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.b755676576 = messageFormatterFn((function(  ) {
  return function(d) { return "開始註冊"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a1568980432 = messageFormatterFn((function(  ) {
  return function(d) { return "稍後提醒我"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a1907528058 = messageFormatterFn((function(  ) {
  return function(d) { return "大功告成！"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.b675132480 = messageFormatterFn((function(  ) {
  return function(d) { return "已啟用生物識別登入功能。"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a1418036456 = messageFormatterFn((function(  ) {
  return function(d) { return "使用生物識別登入"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a392265581 = messageFormatterFn((function(  ) {
  return function(d) { return "使用密碼"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.b1177994232 = messageFormatterFn((function(  ) {
  return function(d) { return "使用生物識別"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a324764479 = messageFormatterFn((function(  ) {
  return function(d) { return "更新密碼"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a1284006429 = messageFormatterFn((function(  ) {
  return function(d) { return "你必須重設密碼才能登入帳戶。"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a1834797773 = messageFormatterFn((function(  ) {
  return function(d) { return "重設密碼"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a1369334035 = messageFormatterFn((function(  ) {
  return function(d) { return "歡迎享用會員禮遇"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a1097214201 = messageFormatterFn((function(  ) {
  return function(d) { return "誠意送你價值 $" + d["0"] + " 積分，伴你展開下次旅程！"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a77135703 = messageFormatterFn((function(  ) {
  return function(d) { return "這些積分現在就可於帳戶裡查看，並在首次預訂時使用。結帳時只要尋找套用積分的選項，便能獲享禮遇！"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.b1639687099 = messageFormatterFn((function(  ) {
  return function(d) { return "你現在已是 Expedia 會員。"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a1132541323 = messageFormatterFn((function(  ) {
  return function(d) { return "你馬上就能透過會員價大慳一筆，並在預訂時賺取積分。"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.b1922719360 = messageFormatterFn((function(  ) {
  return function(d) { return "登入或建立帳戶"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a499837274 = messageFormatterFn((function(  ) {
  return function(d) { return "免費註冊會員，預訂數以萬間酒店即慳平均 " + d["0"] + "%！"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.b1899283928 = messageFormatterFn((function(  ) {
  return function(d) { return "繼續即表示你已閱讀並同意我們的<a href=" + d["1"] + " " + d["3"] + ">條款及細則</a>和<a href=" + d["2"] + " " + d["4"] + ">私隱聲明</a>。"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.b1164748998 = messageFormatterFn((function(  ) {
  return function(d) { return "繼續即表示你已閱讀並同意我們的<a href=" + d["1"] + " " + d["5"] + ">條款及細則</a>、<a href=" + d["2"] + " " + d["6"] + ">私隱聲明</a>和<a href=" + d["3"] + " " + d["7"] + ">" + d["4"] + " 條款及細則</a>。"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a882071637 = messageFormatterFn((function(  ) {
  return function(d) { return "繼續即表示你已閱讀並同意我們的<a href=" + d["1"] + " " + d["4"] + ">條款及細則</a>、<a href=" + d["2"] + " " + d["5"] + ">私隱聲明</a>和 <a href=" + d["3"] + " " + d["6"] + ">One Key 會員計劃條款及細則</a>。"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.b1398857553 = messageFormatterFn((function(  ) {
  return function(d) { return "電郵"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a1288998441 = messageFormatterFn((function(  ) {
  return function(d) { return "請輸入有效的電郵地址。"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.b1642829076 = messageFormatterFn((function(  ) {
  return function(d) { return "Google"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a31652409 = messageFormatterFn((function(  ) {
  return function(d) { return "Facebook"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a1440495581 = messageFormatterFn((function(  ) {
  return function(d) { return "Apple"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a367523626 = messageFormatterFn((function(  ) {
  return function(d) { return "這只適用於個人裝置。為保障帳戶安全，請勿在共用裝置上剔選此項。"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a743618873 = messageFormatterFn((function(  ) {
  return function(d) { return "你嘗試登入了太多次。你需要先等候 " + d["0"] + " 分鐘，才可以再試。"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a1538102923 = messageFormatterFn((function(  ) {
  return function(d) { return "你嘗試登入了太多次。你需要先等候 " + d["0"] + " 分鐘，才可以再試。"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a1542998257 = messageFormatterFn((function(  ) {
  return function(d) { return "你嘗試登入了太多次。你需要先等候 " + d["0"] + " 分鐘，才可以再試。"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a1529540413 = messageFormatterFn((function(  ) {
  return function(d) { return "你嘗試登入了太多次。你需要先等候 " + d["0"] + " 分鐘，才可以再試。"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a367636272 = messageFormatterFn((function(  ) {
  return function(d) { return "你嘗試登入了太多次。你需要先等候 " + d["0"] + " 分鐘，才可以再試。"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a824721973 = messageFormatterFn((function(  ) {
  return function(d) { return "你嘗試登入了太多次。你需要先等候 " + d["0"] + " 分鐘，才可以再試。"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a2141997796 = messageFormatterFn((function(  ) {
  return function(d) { return "只需使用一個帳戶，便能在 Expedia、Hotels.com 及 Vrbo 上賺取獎賞。"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a729688532 = messageFormatterFn((function(  ) {
  return function(d) { return "只需使用一個帳戶，便能在 Expedia、Hotels.com 及 Vrbo 上預訂行程，玩遍全世界。"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.b199036197 = messageFormatterFn((function(  ) {
  return function(d) { return "瀏覽並儲存住宿，與同行親朋好友一起規劃，並查看你的預訂資料。"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.b1597603750 = messageFormatterFn((function(  ) {
  return function(d) { return "我們處於例行安全檢查程序當中，你的帳戶已暫時停用。你的個人資料安全無虞，但帳戶需要重設密碼。"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a207576022 = messageFormatterFn((function(  ) {
  return function(d) { return "登入並預訂住宿以賺取 OneKeyCash"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.b1748254530 = messageFormatterFn((function(  ) {
  return function(d) { return "確認身分"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a1071159644 = messageFormatterFn((function(  ) {
  return function(d) { return "請輸入我們發送到你電郵的安全碼。如收件匣中找不到電郵，請查閱垃圾郵件匣。"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a702834320 = messageFormatterFn((function(  ) {
  return function(d) { return "驗證你的電郵地址"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.b1574876598 = messageFormatterFn((function(  ) {
  return function(d) { return "請輸入我們發送到 " + d["0"] + " 的安全碼以繼續。如果電郵不在收件箱中，請查看垃圾郵件箱。"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a927536892 = messageFormatterFn((function(  ) {
  return function(d) { return "6 位數驗證碼"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.b1824765316 = messageFormatterFn((function(  ) {
  return function(d) { return "重發驗證碼"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.b1149542445 = messageFormatterFn((function(  ) {
  return function(d) { return "(0:" + d["0"] + ")"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.b1269582875 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " 秒後重發驗證碼"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.b1101636875 = messageFormatterFn((function(  ) {
  return function(d) { return "沒有收到電郵？"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.b1125879853 = messageFormatterFn((function(  ) {
  return function(d) { return "你可以在 " + d["0"] + " 秒後索取新的安全碼"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a730233398 = messageFormatterFn((function(  ) {
  return function(d) { return "索取新的安全碼"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.b415288384 = messageFormatterFn((function(  ) {
  return function(d) { return "我們已向你的收件匣發送 6 位數驗證碼。"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a2093420683 = messageFormatterFn((function(  ) {
  return function(d) { return "改為輸入密碼"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.b1559692778 = messageFormatterFn((function(  ) {
  return function(d) { return "驗證碼無效，請再試一次。"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a1626775876 = messageFormatterFn((function(  ) {
  return function(d) { return "驗證碼逾時，請重發並再試一次。"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.b759830727 = messageFormatterFn((function(  ) {
  return function(d) { return "如果電郵不在收件匣中，請查看垃圾郵件匣"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.b1407415840 = messageFormatterFn((function(  ) {
  return function(d) { return "我們更新了使用體驗，需確認你的電郵。請輸入我們發送到你收件箱的安全碼。"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a2001844511 = messageFormatterFn((function(  ) {
  return function(d) { return "系統發生錯誤，請再試一次。"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.b340156696 = messageFormatterFn((function(  ) {
  return function(d) { return "如需更新登入方式，請輸入我們發送到你電郵的安全碼。"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a478119326 = messageFormatterFn((function(  ) {
  return function(d) { return "輸入你的密碼"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.b675713577 = messageFormatterFn((function(  ) {
  return function(d) { return "透過電郵發送安全碼"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a1772831657 = messageFormatterFn((function(  ) {
  return function(d) { return "電郵地址及密碼不符"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a962469746 = messageFormatterFn((function(  ) {
  return function(d) { return "建立密碼"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a2009105649 = messageFormatterFn((function(  ) {
  return function(d) { return "建立密碼 | " + d["0"]; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.b851964708 = messageFormatterFn((function(  ) {
  return function(d) { return "建立密碼"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a629567614 = messageFormatterFn((function(  ) {
  return function(d) { return "你可以使用同一組電郵和密碼登入 Expedia、Hotels.com 及 Vrbo。"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.b489974814 = messageFormatterFn((function(  ) {
  return function(d) { return "建立密碼"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.b2056976133 = messageFormatterFn((function(  ) {
  return function(d) { return "設定密碼，配合其他安全登入方式使用。"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.b2097101264 = messageFormatterFn((function(  ) {
  return function(d) { return "設定新密碼"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a468900723 = messageFormatterFn((function(  ) {
  return function(d) { return "設定新密碼 | " + d["0"]; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a952892442 = messageFormatterFn((function(  ) {
  return function(d) { return "設定新密碼"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a433344640 = messageFormatterFn((function(  ) {
  return function(d) { return "現在你可以使用同一個帳戶登入 Expedia、Hotels.com 及 Vrbo，請為合併的帳戶建立安全的新密碼。"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.b718103392 = messageFormatterFn((function(  ) {
  return function(d) { return "建立密碼"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a1900344776 = messageFormatterFn((function(  ) {
  return function(d) { return "變更密碼"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.b1979351845 = messageFormatterFn((function(  ) {
  return function(d) { return "變更密碼 | " + d["0"]; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.b1388961816 = messageFormatterFn((function(  ) {
  return function(d) { return "請使用獨一無二的高強度密碼。"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.b663112648 = messageFormatterFn((function(  ) {
  return function(d) { return "更新密碼"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.b964270683 = messageFormatterFn((function(  ) {
  return function(d) { return "我們無法為你更改密碼。請再試一次。"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.b1687680509 = messageFormatterFn((function(  ) {
  return function(d) { return "忘記密碼"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a1745554935 = messageFormatterFn((function(  ) {
  return function(d) { return "請輸入電郵，並使用安全碼登入系統。"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.b1453533239 = messageFormatterFn((function(  ) {
  return function(d) { return "發送電郵"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a1805535893 = messageFormatterFn((function(  ) {
  return function(d) { return "聯絡我們"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a715040506 = messageFormatterFn((function(  ) {
  return function(d) { return "刪除資料"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a353377711 = messageFormatterFn((function(  ) {
  return function(d) { return "關閉"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.b1327019949 = messageFormatterFn((function(  ) {
  return function(d) { return "我們正在檢查你的帳戶，請等等。"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a1991284876 = messageFormatterFn((function(  ) {
  return function(d) { return "刪除帳戶"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.b454078480 = messageFormatterFn((function(  ) {
  return function(d) { return "明白了"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a694273364 = messageFormatterFn((function(  ) {
  return function(d) { return "行程完結前無法刪除帳戶。"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.b1088047371 = messageFormatterFn((function(  ) {
  return function(d) { return "為了確保你的行程順利，我們會暫時保留你的帳戶，讓你在必要時聯絡客戶服務部更改預訂。"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.b1874722242 = messageFormatterFn((function(  ) {
  return function(d) { return "很抱歉，你需要先刪除 Vrbo 屋主帳戶"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a80686329 = messageFormatterFn((function(  ) {
  return function(d) { return "請在我們的網站或 App 上瀏覽說明中心，直接聯絡客戶服務團隊以開始程序。"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a1669886633 = messageFormatterFn((function(  ) {
  return function(d) { return "請於行程結束後再刪除帳戶。"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a596816326 = messageFormatterFn((function(  ) {
  return function(d) { return "刪除帳戶的原因"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a974163081 = messageFormatterFn((function(  ) {
  return function(d) { return "收到太多電郵及通知"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a406701087 = messageFormatterFn((function(  ) {
  return function(d) { return "已有另一個 " + d["0"] + " 帳戶"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a1538749850 = messageFormatterFn((function(  ) {
  return function(d) { return "行程已結束，不再需要此帳戶"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a1943052640 = messageFormatterFn((function(  ) {
  return function(d) { return "使用 " + d["0"] + " 預訂的體驗不快"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a510713663 = messageFormatterFn((function(  ) {
  return function(d) { return "其他"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.b975925858 = messageFormatterFn((function(  ) {
  return function(d) { return "略過"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a668786341 = messageFormatterFn((function(  ) {
  return function(d) { return "提交"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.b100402379 = messageFormatterFn((function(  ) {
  return function(d) { return "確定要停用帳戶嗎？停用前先請細閱以下須知："; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.b1951818376 = messageFormatterFn((function(  ) {
  return function(d) { return "你將會永遠失去 " + d["0"] + " 個 Expedia Rewards 積分 (價值 " + d["1"] + ")、價值 " + d["2"] + " 的代用金、優惠券、已儲存行程項目、以及帳戶偏好設定。"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.b1679236935 = messageFormatterFn((function(  ) {
  return function(d) { return "你將會永遠失去 " + d["0"] + " 個 Expedia Rewards 積分 (價值 " + d["1"] + ")、優惠券、已儲存行程項目、以及帳戶偏好設定。"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a1731065467 = messageFormatterFn((function(  ) {
  return function(d) { return "你將會永遠失去行程板、代用金及偏好設定。"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a617834609 = messageFormatterFn((function(  ) {
  return function(d) { return "Hotels.com Rewards：你將會失去價值 " + d["1"] + " 的 " + d["0"] + " 晚獎賞住宿，以及平均價值 " + d["3"] + " 的 " + d["2"] + " 個印花。"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.b1264445630 = messageFormatterFn((function(  ) {
  return function(d) { return "你將會永遠失去代用金、優惠券、已儲存行程項目、以及帳戶偏好設定。"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a1426013930 = messageFormatterFn((function(  ) {
  return function(d) { return "你將會永遠失去 " + d["0"] + " 個 CheapCash (價值 " + d["1"] + ")、價值 " + d["2"] + " 的代用金、優惠券、已儲存行程項目、以及帳戶偏好設定。"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a1099973639 = messageFormatterFn((function(  ) {
  return function(d) { return "你將會永遠失去 " + d["0"] + " 個 CheapCash (價值 " + d["1"] + ")、優惠券、已儲存行程項目、以及帳戶偏好設定。"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a2083730530 = messageFormatterFn((function(  ) {
  return function(d) { return "你將會永遠失去 " + d["0"] + " 個 Orbucks (價值 " + d["1"] + ")、價值 " + d["2"] + " 的代用金、優惠券、已儲存行程項目、以及帳戶偏好設定。"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a1258730383 = messageFormatterFn((function(  ) {
  return function(d) { return "你將會永遠失去 " + d["0"] + " 個 Orbucks (價值 " + d["1"] + ")、優惠券、已儲存行程項目、以及帳戶偏好設定。"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.b1561976584 = messageFormatterFn((function(  ) {
  return function(d) { return "你將會永遠失去 " + d["0"] + " 個 MrJet Rewards (價值 " + d["1"] + ")、價值 " + d["2"] + " 的代用金、優惠券、已儲存行程項目、以及帳戶偏好設定。"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.b1482740423 = messageFormatterFn((function(  ) {
  return function(d) { return "你將會永遠失去 " + d["0"] + " 個 MrJet Rewards (價值 " + d["1"] + ")、優惠券、已儲存行程項目、以及帳戶偏好設定。"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.b527950582 = messageFormatterFn((function(  ) {
  return function(d) { return "你將會永遠失去 " + d["0"] + " 個 BONUS+ (價值 " + d["1"] + ")、價值 " + d["2"] + " 的代用金、優惠券、已儲存行程項目、以及帳戶偏好設定。"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.b1264234009 = messageFormatterFn((function(  ) {
  return function(d) { return "你將會永遠失去 " + d["0"] + " 個 BONUS+ (價值 " + d["1"] + ")、優惠券、已儲存行程項目、以及帳戶偏好設定。"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a1520171924 = messageFormatterFn((function(  ) {
  return function(d) { return "你將會永遠失去優惠券、已儲存行程項目、以及帳戶偏好設定。"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.b1779468887 = messageFormatterFn((function(  ) {
  return function(d) { return "你將會永遠失去價值 " + d["0"] + " 的代用金、優惠券、已儲存行程項目、以及帳戶偏好設定。"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a994107373 = messageFormatterFn((function(  ) {
  return function(d) { return "我們會安全保留部分資料 (例如交易紀錄)，以應付履行法律義務、又或者建立、行使法律權利或因應法律訴訟進行辯護的需求。我們會安全保留這些資料，並在不再需要時刪除、匿名或永久模糊處理。"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a948958623 = messageFormatterFn((function(  ) {
  return function(d) { return "永久刪除帳戶"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a1933095089 = messageFormatterFn((function(  ) {
  return function(d) { return "不要刪除帳戶"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a582344103 = messageFormatterFn((function(  ) {
  return function(d) { return "期望能再次為你服務"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.b1277884792 = messageFormatterFn((function(  ) {
  return function(d) { return "你的刪除申請需時幾星期才能完成處理，你可能仍會在我們系統更新時收到通訊。"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a272844194 = messageFormatterFn((function(  ) {
  return function(d) { return "請再試一次"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.b1176440001 = messageFormatterFn((function(  ) {
  return function(d) { return "系統發生錯誤，請重新提交刪除帳戶申請，或在幾分鐘後再試一次。"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a1601438663 = messageFormatterFn((function(  ) {
  return function(d) { return "關閉"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.b1538734368 = messageFormatterFn((function(  ) {
  return function(d) { return "旅遊證件姓名"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.b1242026000 = messageFormatterFn((function(  ) {
  return function(d) { return "請確保帳戶名稱與旅遊證件 (例如護照或駕照) 上的姓名相同。下次預訂時，我們會為你預先填好資料。"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.b851276962 = messageFormatterFn((function(  ) {
  return function(d) { return "透過電郵接收 " + d["0"] + " 的優惠、推廣及其他資訊。"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.b1939669039 = messageFormatterFn((function(  ) {
  return function(d) { return "透過電郵接收 " + d["0"] + " 的優惠、推廣及其他資訊。你可以隨時取消訂閱推廣電郵。"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.b36935796 = messageFormatterFn((function(  ) {
  return function(d) { return "帳戶資料"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a18876567 = messageFormatterFn((function(  ) {
  return function(d) { return "帳戶資料 | " + d["0"]; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a992357346 = messageFormatterFn((function(  ) {
  return function(d) { return "接收有關 " + d["0"] + " 優惠、推廣和其他資訊的電郵。你可以隨時取消訂閱。"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a1705044714 = messageFormatterFn((function(  ) {
  return function(d) { return "帳戶 | " + d["0"]; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a1739663166 = messageFormatterFn((function(  ) {
  return function(d) { return "掌握最新消息"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a1675548008 = messageFormatterFn((function(  ) {
  return function(d) { return "市場營銷許可"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a11103223 = messageFormatterFn((function(  ) {
  return function(d) { return "Expedia Rewards"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.b2040027189 = messageFormatterFn((function(  ) {
  return function(d) { return "CheapCash"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.b623896061 = messageFormatterFn((function(  ) {
  return function(d) { return "Orbitz Rewards"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a193076843 = messageFormatterFn((function(  ) {
  return function(d) { return "BONUS+"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.b1372224713 = messageFormatterFn((function(  ) {
  return function(d) { return "MrJet"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.b2089791982 = messageFormatterFn((function(  ) {
  return function(d) { return "Hotels.com Rewards"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a422320250 = messageFormatterFn((function(  ) {
  return function(d) { return "One Key"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.b1141289881 = messageFormatterFn((function(  ) {
  return function(d) { return "對不起，你需先等待行程結束"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.b395296183 = messageFormatterFn((function(  ) {
  return function(d) { return "對不起，你需先等待接下來的行程結束"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a417310225 = messageFormatterFn((function(  ) {
  return function(d) { return "你可以在帳戶中查看預訂資料，並尋求所需支援。請於行程結束後再刪除帳戶。"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a57715571 = messageFormatterFn((function(  ) {
  return function(d) { return "你可以在帳戶中查看預訂資料，並尋求所需支援。請於行程結束後再刪除帳戶。"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a1348841324 = messageFormatterFn((function(  ) {
  return function(d) { return "對不起，你暫時無法刪除帳戶"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.b679417194 = messageFormatterFn((function(  ) {
  return function(d) { return "此帳戶亦有用來在 Vrbo 上架住宿。刪除帳戶前，你需先登入 Vrbo 屋主 App 或網站，移除現時上架的房源。"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a525310809 = messageFormatterFn((function(  ) {
  return function(d) { return "請選擇你離開的原因。"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a1005569778 = messageFormatterFn((function(  ) {
  return function(d) { return "我已使用另一個電郵註冊帳戶"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a1369304947 = messageFormatterFn((function(  ) {
  return function(d) { return "我的預訂體驗不快"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a867816840 = messageFormatterFn((function(  ) {
  return function(d) { return "很可惜你選擇離開。請留意：帳戶一經刪除，即無法復原，同時會影響你在 Expedia、Hotels.com 及 Vrbo 的資料，停用前請先細閱以下須知。"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a1887666259 = messageFormatterFn((function(  ) {
  return function(d) { return "很可惜你選擇離開。請留意：帳戶一經刪除便無法復原，同時會影響你在 Expedia、Wotif、Hotels.com 及 Vrbo 的資料，停用前請先細閱以下須知："; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.b1789618636 = messageFormatterFn((function(  ) {
  return function(d) { return "你將永久失去 Expedia、Hotels.com 及 Vrbo 上的帳戶紀錄、偏好設定及儲存項目。"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.b306311169 = messageFormatterFn((function(  ) {
  return function(d) { return "你將永久失去 Expedia、Wotif、Hotels.com 及 Vrbo 上的帳戶紀錄、偏好設定及儲存項目。"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.b1373947928 = messageFormatterFn((function(  ) {
  return function(d) { return "你將永久失去所有 OneKeyCash，當中包括一切處理中的 OneKeyCash，以及 One Key 會員等級和一切相關禮遇。"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a2084076766 = messageFormatterFn((function(  ) {
  return function(d) { return "你將永久失去一切處理中的 OneKeyCash，以及 One Key 會員等級和一切相關禮遇。"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a980099917 = messageFormatterFn((function(  ) {
  return function(d) { return "你將永久失去 " + d["0"] + " OneKeyCash、一切處理中的 OneKeyCash，以及 One Key 會員等級和一切相關禮遇。"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a1446048681 = messageFormatterFn((function(  ) {
  return function(d) { return "Hotels.com Rewards 信用卡卡主將無法再就信用卡活動賺取獎賞。"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a50995398 = messageFormatterFn((function(  ) {
  return function(d) { return "你將永久失去一切 Expedia Rewards 積分，當中包括所有已確認及處理中的 Expedia Rewards 積分、Hotels.com Rewards 印花與獎賞住宿，以及獎賞等級。"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a1181743804 = messageFormatterFn((function(  ) {
  return function(d) { return "你將永久失去所有處理中的 Expedia Rewards 積分、Hotels.com Rewards 印花與獎賞住宿，以及獎賞等級。"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.b1686458622 = messageFormatterFn((function(  ) {
  return function(d) { return "你將永久失去所有 Expedia、Hotels.com 或 Vrbo 優惠券及代用金。"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a1714804301 = messageFormatterFn((function(  ) {
  return function(d) { return "你將永久失去所有 Expedia、Wotif、Hotels.com 或 Vrbo 優惠券及代用金。"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.b1745103205 = messageFormatterFn((function(  ) {
  return function(d) { return "你的 Expedia、Hotels.com 或 Vrbo 刪除帳戶申請需時幾星期才能完成處理，你可能仍會在我們系統更新時收到通訊。"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.b292083930 = messageFormatterFn((function(  ) {
  return function(d) { return "你的 Expedia、Wotif、Hotels.com 或 Vrbo 刪除帳戶申請需時幾星期才能完成處理，你可能仍會在我們系統更新時收到通訊。"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a908306896 = messageFormatterFn((function(  ) {
  return function(d) { return "如刪除帳戶，你的 One Key Card 將會停用，任何消費亦不會再獲得 OneKeyCash。Wells Fargo 會聯絡你確認停用該卡。"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.b1066433446 = messageFormatterFn((function(  ) {
  return function(d) { return "如刪除帳戶，你的 One Key+ Card 將會停用，任何消費亦不會再獲得 OneKeyCash。Wells Fargo 會聯絡你確認停用該卡。"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a1273957649 = messageFormatterFn((function(  ) {
  return function(d) { return "登入或建立帳戶，為行程賺取 OneKeyCash"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.b1386136087 = messageFormatterFn((function(  ) {
  return function(d) { return "登入或建立帳戶，為這次住宿賺取獎賞"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a1864820944 = messageFormatterFn((function(  ) {
  return function(d) { return "以訪客身份結帳"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.b350343234 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " 帳戶登入：加入手機號碼"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.b1610446926 = messageFormatterFn((function(  ) {
  return function(d) { return "發生錯誤"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.b367742124 = messageFormatterFn((function(  ) {
  return function(d) { return "請再嘗試登入"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.b626232373 = messageFormatterFn((function(  ) {
  return function(d) { return "確定"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.b1505507762 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " 標誌"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a1949962593 = messageFormatterFn((function(  ) {
  return function(d) { return "帳戶"; }
})(), Globalize("zh-HK").pluralGenerator({}));
Globalize.a1019197581 = dateToPartsFormatterFn({"2":Globalize("zh-HK").numberFormatter({"raw":"00"}),"4":Globalize("zh-HK").numberFormatter({"raw":"0000"})}, {"pattern":"yyyy-MM-dd","timeSeparator":":"});
Globalize.b95348787 = dateToPartsFormatterFn({"2":Globalize("zh-HK").numberFormatter({"raw":"00"}),"4":Globalize("zh-HK").numberFormatter({"raw":"0000"})}, {"pattern":"dd/MM/yyyy","timeSeparator":":"});
Globalize.b1780116640 = dateToPartsFormatterFn({"1":Globalize("zh-HK").numberFormatter({"raw":"0"}),"4":Globalize("zh-HK").numberFormatter({"raw":"0000"})}, {"pattern":"d/M/yyyy","timeSeparator":":"});
Globalize.a1392396698 = dateToPartsFormatterFn({"1":Globalize("zh-HK").numberFormatter({"raw":"0"}),"4":Globalize("zh-HK").numberFormatter({"raw":"0000"})}, {"pattern":"yyyy/M/d","timeSeparator":":"});
Globalize.b41207763 = dateToPartsFormatterFn({"2":Globalize("zh-HK").numberFormatter({"raw":"00"}),"4":Globalize("zh-HK").numberFormatter({"raw":"0000"})}, {"pattern":"dd.MM.yyyy","timeSeparator":":"});
Globalize.a968553826 = dateToPartsFormatterFn({"1":Globalize("zh-HK").numberFormatter({"raw":"0"}),"4":Globalize("zh-HK").numberFormatter({"raw":"0000"})}, {"pattern":"d.M.yyyy","timeSeparator":":"});
Globalize.a1756514253 = dateToPartsFormatterFn({"2":Globalize("zh-HK").numberFormatter({"raw":"00"}),"4":Globalize("zh-HK").numberFormatter({"raw":"0000"})}, {"pattern":"yyyy/MM/dd","timeSeparator":":"});
Globalize.a12933261 = dateToPartsFormatterFn({"2":Globalize("zh-HK").numberFormatter({"raw":"00"}),"4":Globalize("zh-HK").numberFormatter({"raw":"0000"})}, {"pattern":"dd-MM-yyyy","timeSeparator":":"});
Globalize.a542427533 = dateToPartsFormatterFn({"2":Globalize("zh-HK").numberFormatter({"raw":"00"}),"4":Globalize("zh-HK").numberFormatter({"raw":"0000"})}, {"pattern":"MM/dd/yyyy","timeSeparator":":"});
Globalize.b2021688032 = dateToPartsFormatterFn({"1":Globalize("zh-HK").numberFormatter({"raw":"0"}),"4":Globalize("zh-HK").numberFormatter({"raw":"0000"})}, {"pattern":"M/d/yyyy","timeSeparator":":"});
Globalize.b759627731 = dateToPartsFormatterFn({"2":Globalize("zh-HK").numberFormatter({"raw":"00"}),"4":Globalize("zh-HK").numberFormatter({"raw":"0000"})}, {"pattern":"yyyy.MM.dd","timeSeparator":":"});
Globalize.a1803064242 = dateToPartsFormatterFn({}, {"pattern":"EEEEE","timeSeparator":":","days":{"E":{"5":{"sun":"日","mon":"一","tue":"二","wed":"三","thu":"四","fri":"五","sat":"六"}}}});
Globalize.b634604147 = dateToPartsFormatterFn({}, {"pattern":"EEEE","timeSeparator":":","days":{"E":{"4":{"sun":"星期日","mon":"星期一","tue":"星期二","wed":"星期三","thu":"星期四","fri":"星期五","sat":"星期六"}}}});
Globalize.b1887849587 = dateToPartsFormatterFn({}, {"pattern":"MMMM","timeSeparator":":","months":{"M":{"4":{"1":"1月","2":"2月","3":"3月","4":"4月","5":"5月","6":"6月","7":"7月","8":"8月","9":"9月","10":"10月","11":"11月","12":"12月"}}}});
Globalize.b548273037 = dateToPartsFormatterFn({"1":Globalize("zh-HK").numberFormatter({"raw":"0"})}, {"pattern":"d","timeSeparator":":"});
Globalize.b37941312 = dateToPartsFormatterFn({"1":Globalize("zh-HK").numberFormatter({"raw":"0"}),"2":Globalize("zh-HK").numberFormatter({"raw":"00"})}, {"pattern":"M/d/yy","timeSeparator":":"});
Globalize.a577588993 = dateToPartsFormatterFn({"1":Globalize("zh-HK").numberFormatter({"raw":"0"})}, {"pattern":"M月d日","timeSeparator":":"});
Globalize.a706028456 = dateToPartsFormatterFn({"1":Globalize("zh-HK").numberFormatter({"raw":"0"})}, {"pattern":"M月d日","timeSeparator":":"});
Globalize.b1825900531 = dateToPartsFormatterFn({"1":Globalize("zh-HK").numberFormatter({"raw":"0"})}, {"pattern":"y年MMMM月d日","timeSeparator":":","months":{"M":{"4":{"1":"1月","2":"2月","3":"3月","4":"4月","5":"5月","6":"6月","7":"7月","8":"8月","9":"9月","10":"10月","11":"11月","12":"12月"}}}});
Globalize.a79586675 = dateToPartsFormatterFn({"1":Globalize("zh-HK").numberFormatter({"raw":"0"})}, {"pattern":"y年M月","timeSeparator":":"});
Globalize.a80271868 = dateToPartsFormatterFn({"1":Globalize("zh-HK").numberFormatter({"raw":"0"})}, {"pattern":"y年M月d日","timeSeparator":":"});
Globalize.b1010958655 = dateToPartsFormatterFn({"1":Globalize("zh-HK").numberFormatter({"raw":"0"})}, {"pattern":"MMM月d日EEEE","timeSeparator":":","months":{"M":{"3":{"1":"1月","2":"2月","3":"3月","4":"4月","5":"5月","6":"6月","7":"7月","8":"8月","9":"9月","10":"10月","11":"11月","12":"12月"}}},"days":{"E":{"4":{"sun":"星期日","mon":"星期一","tue":"星期二","wed":"星期三","thu":"星期四","fri":"星期五","sat":"星期六"}}}});
Globalize.a698640288 = dateToPartsFormatterFn({"1":Globalize("zh-HK").numberFormatter({"raw":"0"})}, {"pattern":"M月d日E","timeSeparator":":","days":{"E":{"1":{"sun":"週日","mon":"週一","tue":"週二","wed":"週三","thu":"週四","fri":"週五","sat":"週六"}}}});
Globalize.a1397911332 = dateFormatterFn(Globalize("zh-HK").dateToPartsFormatter({"raw":"yyyy-MM-dd"}));
Globalize.a283364964 = dateFormatterFn(Globalize("zh-HK").dateToPartsFormatter({"raw":"dd/MM/yyyy"}));
Globalize.a34800567 = dateFormatterFn(Globalize("zh-HK").dateToPartsFormatter({"raw":"d/M/yyyy"}));
Globalize.b1087653391 = dateFormatterFn(Globalize("zh-HK").dateToPartsFormatter({"raw":"yyyy/M/d"}));
Globalize.a337505988 = dateFormatterFn(Globalize("zh-HK").dateToPartsFormatter({"raw":"dd.MM.yyyy"}));
Globalize.b1511496263 = dateFormatterFn(Globalize("zh-HK").dateToPartsFormatter({"raw":"d.M.yyyy"}));
Globalize.a2135228004 = dateFormatterFn(Globalize("zh-HK").dateToPartsFormatter({"raw":"yyyy/MM/dd"}));
Globalize.a391647012 = dateFormatterFn(Globalize("zh-HK").dateToPartsFormatter({"raw":"dd-MM-yyyy"}));
Globalize.a921141284 = dateFormatterFn(Globalize("zh-HK").dateToPartsFormatter({"raw":"MM/dd/yyyy"}));
Globalize.b206770825 = dateFormatterFn(Globalize("zh-HK").dateToPartsFormatter({"raw":"M/d/yyyy"}));
Globalize.b380913980 = dateFormatterFn(Globalize("zh-HK").dateToPartsFormatter({"raw":"yyyy.MM.dd"}));
Globalize.a1651890875 = dateFormatterFn(Globalize("zh-HK").dateToPartsFormatter({"raw":"EEEEE"}));
Globalize.b1470764700 = dateFormatterFn(Globalize("zh-HK").dateToPartsFormatter({"raw":"EEEE"}));
Globalize.a1570957156 = dateFormatterFn(Globalize("zh-HK").dateToPartsFormatter({"raw":"MMMM"}));
Globalize.a35010556 = dateFormatterFn(Globalize("zh-HK").dateToPartsFormatter({"raw":"d"}));
Globalize.b429348393 = dateFormatterFn(Globalize("zh-HK").dateToPartsFormatter({"raw":"M/d/yy"}));
Globalize.a1005447562 = dateFormatterFn(Globalize("zh-HK").dateToPartsFormatter({"skeleton":"MMMd"}));
Globalize.a1084742207 = dateFormatterFn(Globalize("zh-HK").dateToPartsFormatter({"skeleton":"MMMMd"}));
Globalize.a1324291158 = dateFormatterFn(Globalize("zh-HK").dateToPartsFormatter({"skeleton":"yMMMMd"}));
Globalize.a458300426 = dateFormatterFn(Globalize("zh-HK").dateToPartsFormatter({"skeleton":"yMMMM"}));
Globalize.a458985619 = dateFormatterFn(Globalize("zh-HK").dateToPartsFormatter({"skeleton":"yMMMd"}));
Globalize.b1628689206 = dateFormatterFn(Globalize("zh-HK").dateToPartsFormatter({"skeleton":"MMMEEEEd"}));
Globalize.a1077354039 = dateFormatterFn(Globalize("zh-HK").dateToPartsFormatter({"skeleton":"MMMEd"}));
Globalize.b1282994221 = dateParserFn(Globalize("zh-HK").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"yyyy-MM-dd","digitsRe":/\d/});
Globalize.a1897426707 = dateParserFn(Globalize("zh-HK").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"dd/MM/yyyy","digitsRe":/\d/});
Globalize.b754580442 = dateParserFn(Globalize("zh-HK").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"d/M/yyyy","digitsRe":/\d/});
Globalize.b1877034400 = dateParserFn(Globalize("zh-HK").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"yyyy/M/d","digitsRe":/\d/});
Globalize.a1951567731 = dateParserFn(Globalize("zh-HK").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"dd.MM.yyyy","digitsRe":/\d/});
Globalize.a1994090024 = dateParserFn(Globalize("zh-HK").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"d.M.yyyy","digitsRe":/\d/});
Globalize.b545677549 = dateParserFn(Globalize("zh-HK").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"yyyy/MM/dd","digitsRe":/\d/});
Globalize.a2005708755 = dateParserFn(Globalize("zh-HK").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"dd-MM-yyyy","digitsRe":/\d/});
Globalize.b1759764269 = dateParserFn(Globalize("zh-HK").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"MM/dd/yyyy","digitsRe":/\d/});
Globalize.b996151834 = dateParserFn(Globalize("zh-HK").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"M/d/yyyy","digitsRe":/\d/});
Globalize.a1233147763 = dateParserFn(Globalize("zh-HK").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"yyyy.MM.dd","digitsRe":/\d/});
Globalize.b836941652 = dateParserFn(Globalize("zh-HK").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"EEEEE","digitsRe":/\d/,"gregorian/days/format/narrow":[["sun",/^日/],["mon",/^一/],["tue",/^二/],["wed",/^三/],["thu",/^四/],["fri",/^五/],["sat",/^六/]]});
Globalize.a1912633683 = dateParserFn(Globalize("zh-HK").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"EEEE","digitsRe":/\d/,"gregorian/days/format/wide":[["sun",/^星期日/],["mon",/^星期一/],["tue",/^星期二/],["wed",/^星期三/],["thu",/^星期四/],["fri",/^星期五/],["sat",/^星期六/]]});
Globalize.a659388243 = dateParserFn(Globalize("zh-HK").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"MMMM","digitsRe":/\d/,"gregorian/months/format/wide":[["10",/^10月/],["11",/^11月/],["12",/^12月/],["1",/^1月/],["2",/^2月/],["3",/^3月/],["4",/^4月/],["5",/^5月/],["6",/^6月/],["7",/^7月/],["8",/^8月/],["9",/^9月/]]});
Globalize.b1522776467 = dateParserFn(Globalize("zh-HK").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"d","digitsRe":/\d/});
Globalize.b273745402 = dateParserFn(Globalize("zh-HK").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"M/d/yy","digitsRe":/\d/});
Globalize.b1990527237 = dateParserFn(Globalize("zh-HK").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"M月d日","digitsRe":/\d/});
Globalize.b1596163346 = dateParserFn(Globalize("zh-HK").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"M月d日","digitsRe":/\d/});
Globalize.b179402361 = dateParserFn(Globalize("zh-HK").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"y年MMMM月d日","digitsRe":/\d/,"gregorian/months/format/wide":[["10",/^10月/],["11",/^11月/],["12",/^12月/],["1",/^1月/],["2",/^2月/],["3",/^3月/],["4",/^4月/],["5",/^5月/],["6",/^6月/],["7",/^7月/],["8",/^8月/],["9",/^9月/]]});
Globalize.a2072362169 = dateParserFn(Globalize("zh-HK").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"y年M月","digitsRe":/\d/});
Globalize.a2073047362 = dateParserFn(Globalize("zh-HK").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"y年M月d日","digitsRe":/\d/});
Globalize.a725817787 = dateParserFn(Globalize("zh-HK").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"MMM月d日EEEE","digitsRe":/\d/,"gregorian/months/format/abbreviated":[["10",/^10月/],["11",/^11月/],["12",/^12月/],["1",/^1月/],["2",/^2月/],["3",/^3月/],["4",/^4月/],["5",/^5月/],["6",/^6月/],["7",/^7月/],["8",/^8月/],["9",/^9月/]],"gregorian/days/format/wide":[["sun",/^星期日/],["mon",/^星期一/],["tue",/^星期二/],["wed",/^星期三/],["thu",/^星期四/],["fri",/^星期五/],["sat",/^星期六/]]});
Globalize.b1603551514 = dateParserFn(Globalize("zh-HK").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"M月d日E","digitsRe":/\d/,"gregorian/days/format/abbreviated":[["sun",/^週日/],["mon",/^週一/],["tue",/^週二/],["wed",/^週三/],["thu",/^週四/],["fri",/^週五/],["sat",/^週六/]]});
module.exports = Globalize;
